<template>
    <div class="flex">
      <vx-card class="lg:w-1/2 mr-5">
          <div class="vx-card__title">
            <h4 class="mb-4">Рассылка «{{ task.name }}»</h4>
          </div>
          <ul>
              <li class="flex mb-2">
                <div class="mr-2 font-bold">Статус</div>
                <vs-chip :color="uiTaskStatus.color">{{ uiTaskStatus.value }}</vs-chip>
              </li>
              <li class="flex mb-2">
                  <div class="mr-2 font-bold">Описание</div>
                  <div>{{ task.description }}</div>
              </li>
              <li class="flex mb-2">
                <div class="mr-2 font-bold">#Тег</div>
                <div>{{ task.tag }}</div>
              </li>
              <li class="flex mb-2">
                <div class="mr-2 font-bold">Получателей</div>
                <div>
                  <vx-tooltip text="Осуществить импорт / экспорт можно во вкадке Получатели" position="bottom" delay=".3s">
                    {{ task.receivers_total }}
                    <vs-icon icon-pack="feather" icon="icon-info" />
                  </vx-tooltip>
                </div>
              </li>
              <li class="mt-2">
                <div class="font-bold">Шаблон сообщения</div>
                <div class="ml-1 mt-2" v-html="task.message_example || task.template" />
              </li>
          </ul>
          <div v-if="buttonState" class="flex justify-start mt-6">
              <vs-button
                  id="button-with-loading"
                  @click="buttonState.method"
                  class="vs-con-loading__container"
                  :color="buttonState.color"
                  :disabled="buttonState.disabled"
              >
                {{ buttonState.text }}
              </vs-button>
          </div>
      </vx-card>
      <vx-card class="lg:w-1/2">
          <AnalyticsTab :analytics="analytics" :status="task.status" />
      </vx-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BulkDeliveryService from '@/api/http/models/bulkDelivery/BulkDeliveryService'
import BulkDeliveryHelpers from '@/pages/bulk-delivery/mixins/helpers'
import AnalyticsTab from '@/pages/bulk-delivery/components/AnalyticsTab'

export default {
  components: {
    AnalyticsTab
  },
  props: {
    task: {
      type: Object,
      required: true
    },
    analytics: {
      type: Object,
      required: true
    },
    receiversCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      status: this.task.status
    }
  },
  mixins: [BulkDeliveryHelpers],
  computed: {
    ...mapGetters(['authUserCompany']),
    taskStatus () {
      return this.status || this.task.status
    },
    uiTaskStatus () {
      return {
        value: this.getStatus({ status: this.taskStatus }),
        color: this.getStatusColor({ status: this.taskStatus })
      }
    },

    buttonState () {
      const fsm = {
        draft: 'under_moderation',
        passed: 'in_progress',
        in_progress: 'paused',
        paused: 'in_progress'
      }

      const state = {
        draft: {
          text: 'Отправить на модерацию',
          color: 'primary',
          disabled: this.receiversCount === 0,
          method: () =>  {
            this.changeStatus(fsm.draft)
          }
        },
        passed: {
          text: 'Запустить',
          color: 'success',
          disabled: false,
          method: () =>  {
            this.changeStatus(fsm.passed)
          }
        },
        in_progress: {
          text: 'Приостановить',
          color: 'secondary',
          disabled: false,
          method: () =>  {
            this.changeStatus(fsm.in_progress)
          }
        },
        paused: {
          text: 'Возобновить',
          color: 'success',
          disabled: false,
          method: () =>  {
            this.changeStatus(fsm.paused)
          }
        }
      }

      return state[this.taskStatus]
    }
  },
  methods: {
    async changeStatus (newStatus) {
      try {
        const { status } = await BulkDeliveryService.changeStatus(this.authUserCompany.slug, this.task.slug, newStatus)
        if (status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Успешно',
            text: 'Статус рассылки изменен'
          })
          this.$emit('changeStatus', this.status = newStatus)
          return
        }

        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка',
          text: 'Ошибка при изменении статуса'
        })
      } catch {
        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка',
          text: 'Ошибка при изменении статуса'
        })
      }
    }
  }
}
</script>
